module.exports = __webpack_public_path__ + "static/media/environment.c5f585c6.png";